import gql from 'graphql-tag'

export default gql`
  query RouteAdminFeaturesGlobalIndexQuery {
    features {
      id
      name
      enabled
    }
  }
`



// WEBPACK FOOTER //
// ./src/routes/admin/features/global/index.query.js